import { gql } from '@apollo/client';

export * from './beneficiaryUpdate.mutation.generated';

export const BENEFICIARY_UPDATE = gql`
  mutation beneficiaryUpdate($beneficiaryId: ID!, $beneficiaryParams: EscrowPartyParams!) {
    beneficiaryUpdate(input: { beneficiaryId: $beneficiaryId, beneficiaryParams: $beneficiaryParams }) {
      success
      errors
      beneficiary {
        city
        companyName
        companyRegistrationNumber
        companyWebsite
        country
        id
        postalCode
        region
        street
        streetNumber
      }
    }
  }
`;
